import React from 'react';

import { Button } from '@app/components/ui/button';
import { Dialog, DialogClose, DialogContent, DialogTitle } from '@app/components/ui/dialog';
import { TerminalIcon, XIcon } from '@app/components/ui/icons';

import CliLogin from './CliLogin';

export interface CliLoginDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * A dialog that displays login instructions for Promptfoo CLI.
 * Keeps dialog chrome separate from the shared CLI login content so controls remain visible while
 * long generated-token states scroll independently.
 */
export const CliLoginDialog: React.FC<CliLoginDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      <DialogContent
        hideCloseButton
        className="flex max-h-[90vh] flex-col overflow-hidden border-0 bg-background p-0 sm:max-w-4xl"
        data-testid="cli-login-dialog"
      >
        <header className="flex shrink-0 items-center justify-between gap-4 border-b border-border bg-background px-6 py-4 sm:px-8">
          <div className="flex min-w-0 items-center gap-3">
            <TerminalIcon className="size-5 shrink-0 text-primary" />
            <DialogTitle className="truncate text-xl">CLI Login</DialogTitle>
          </div>

          <DialogClose asChild>
            <Button
              aria-label="Close CLI login dialog"
              className="shrink-0 text-muted-foreground"
              size="icon"
              variant="ghost"
            >
              <XIcon className="size-4" />
            </Button>
          </DialogClose>
        </header>

        <div
          className="min-h-0 overflow-y-auto px-6 py-6 sm:px-8 sm:py-6"
          data-testid="cli-login-dialog-body"
        >
          <CliLogin showShareStep={false} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CliLoginDialog;
